import '@/styles/index.scss'; // global css
import Vue from 'vue';
import VueJsonp from 'vue-jsonp';
import App from './App.vue';
import './directive/index';
import router from './router';
import store from './store';
import { Dialog } from 'vant';
import VueTouch from 'vue-touch';

import 'vant/lib/index.css';
Vue.config.productionTip = false;
Vue.use(VueJsonp);
Vue.use(Dialog);
Vue.use(VueTouch,{name:'v-touch'})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
